import {SENSOR_SPACING_FORMULA} from "../utils/settings";


const getSensorSpacing = (mountHeight) => {
    return ((SENSOR_SPACING_FORMULA.slope * mountHeight + SENSOR_SPACING_FORMULA.yIntercept))
}
export default getSensorSpacing